import { forwardRef } from "react";

const Input = forwardRef(function Input(
  { number = false, error = false, size, className = "", ...rest },
  ref
) {
  const classes = [
    "peb-input",
    number ? "peb-input--number" : "",
    size === "sm" ? "peb-input--sm" : "",
    error ? "peb-input--error" : "",
    className,
  ].filter(Boolean).join(" ");
  return <input ref={ref} className={classes} {...rest} />;
});

export default Input;
